export interface WicketLoginClientConfig {
  apiUrls: WicketApiUrls;
  appId: number;
  fanApplicationSub: string;
  wicketProfileUrl: string;
  wicketLoginUrl: string;
  redirectParams: RedirectParams;
}

export interface WicketApiUrls {
  apiProfileUrl: string;
  apiDictionariesUrl: string;
  amazonAWS: string;
}

export interface RedirectParams {
  user: string;
  clear: string;
}
